import { render, staticRenderFns } from "./DetailTravel.vue?vue&type=template&id=69e725f6"
import script from "./DetailTravel.vue?vue&type=script&lang=js"
export * from "./DetailTravel.vue?vue&type=script&lang=js"
import style0 from "./DetailTravel.vue?vue&type=style&index=0&id=69e725f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports